module.exports = __webpack_public_path__ + "static/media/A TRIAL 2-if-wrong.f4a1313d.mp3";